export interface TimeAxisRange {
  min: number;
  max: number;
}

function isSameCalendarDay(first: Date, second: Date): boolean {
  return (
    first.getFullYear() === second.getFullYear() &&
    first.getMonth() === second.getMonth() &&
    first.getDate() === second.getDate()
  );
}

function isSameCalendarMonth(first: Date, second: Date): boolean {
  return first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth();
}

function isSameCalendarYear(first: Date, second: Date): boolean {
  return first.getFullYear() === second.getFullYear();
}

/** Formats a time-axis tick while omitting date parts already shared by the selected range. */
export function formatTimeAxisLabel(timestamp: number, range: TimeAxisRange): string {
  const date = new Date(timestamp);
  const rangeStart = new Date(range.min);
  const rangeEnd = new Date(range.max);

  const options: Intl.DateTimeFormatOptions = isSameCalendarDay(rangeStart, rangeEnd)
    ? { hour: "2-digit", minute: "2-digit", hour12: false }
    : isSameCalendarMonth(rangeStart, rangeEnd)
      ? { day: "numeric", hour: "2-digit", minute: "2-digit", hour12: false }
      : isSameCalendarYear(rangeStart, rangeEnd)
        ? { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit", hour12: false }
        : {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          };

  return new Intl.DateTimeFormat(undefined, options).format(date);
}
